import styles from "./BurgerMenu.module.scss";
import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import useAppSelector from "../../hooks/useAppSelector";
import LanguageSelect from "../shared/LanguageSelect/LanguageSelect";
import useAppDispatch from "../../hooks/useAppDispatch";
import { useTranslation } from "react-i18next";
import { logout } from "../../store/userProfile/userProfileSlice";
import { AuthService } from "../../services/auth.service";
import { setProfileImage } from "../../helper/imagePaths";
import { setLocationToInitial } from "../../store/userLocation/userLocationSlice";
import ConfirmPopup from "../shared/ConfirmPopup/ConfirmPopup";
import attentionIcon from "../../assets/images/icons/attention.svg";

const BurgerMenu = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const { isAuthorized, user } = useAppSelector((state) => state.userProfileSlice);
  const [showConfirmPopupForLogout, setShowConfirmPopupForLogout] = useState(false);

  const handleMenuBtn = (event: React.MouseEvent<HTMLDivElement>) => {
    event.preventDefault();
    event.stopPropagation();
    setIsOpen(!isOpen);
  };

  const handleOnLogin = () => {
    navigate("/login");
    setIsOpen(false);
  };

  const handleOnGetStarted = () => {
    navigate("/your-location");
    setIsOpen(false);
  };

  const handelSignOut = () => {
    dispatch(logout());
    dispatch(setLocationToInitial());
    // dispatch(setUserSubscriptionToInitial());
    AuthService.logout();
    setIsOpen(false);
    closeConfirmSignOutPopup();
    navigate("/login");
  };

  const closeConfirmSignOutPopup = () => {
    setShowConfirmPopupForLogout(false);
  };

  const handleMenuItem = () => {
    setIsOpen(false);
  };

  return (
    <>
      <div
        className={`${styles.menuBtn} ${isOpen && styles.active}`}
        onClick={(event) => handleMenuBtn(event)}
      >
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div className={`${styles.menuWrapper} ${isOpen && styles.active}`}>
        <div className={styles.content}>
          {isAuthorized && user && (
            <div className={styles.profileWrapper}>
              <div
                className={styles.profileImage}
                style={{ backgroundImage: `url(${setProfileImage(user)})` }}
              ></div>
              <p className={styles.name}>
                {user.firstname} {user.lastname}
              </p>
            </div>
          )}
          <nav className={styles.nav}>
            <ul className={styles.menu}>
              {/*{isAuthorized && (*/}
              {/*    <li>*/}
              {/*        <NavLink*/}
              {/*            onClick={handleMenuItem}*/}
              {/*            className={({ isActive }) => isActive ? `${styles.link} ${styles.active}` : styles.link}*/}
              {/*            to={"/settings"}*/}
              {/*        >*/}
              {/*            {t("AccountSettings")}*/}
              {/*        </NavLink>*/}
              {/*    </li>*/}
              {/*)}*/}
              <li>
                <NavLink
                  onClick={handleMenuItem}
                  className={({ isActive }) =>
                    isActive ? `${styles.link} ${styles.active}` : styles.link
                  }
                  to={"/"}
                >
                  {t("Home")}
                </NavLink>
              </li>
              <li>
                <NavLink
                  onClick={handleMenuItem}
                  className={({ isActive }) =>
                    isActive ? `${styles.link} ${styles.active}` : styles.link
                  }
                  to={"/list-your-business"}
                >
                  {t("ListYourBusiness")}
                </NavLink>
              </li>
              <li>
                <NavLink
                  onClick={handleMenuItem}
                  className={({ isActive }) =>
                    isActive ? `${styles.link} ${styles.active}` : styles.link
                  }
                  to={"/plans-and-credits"}
                >
                  {t("PlansAndCredits")}
                </NavLink>
              </li>
              <li>
                <NavLink
                  onClick={handleMenuItem}
                  className={({ isActive }) =>
                    isActive ? `${styles.link} ${styles.active}` : styles.link
                  }
                  to={"/gyms-location"}
                >
                  {t("ClassesAndBookings")}
                </NavLink>
              </li>
              <li>
                <NavLink
                  onClick={handleMenuItem}
                  className={({ isActive }) =>
                    isActive ? `${styles.link} ${styles.active}` : styles.link
                  }
                  to={"/corporate-wellness"}
                >
                  {t("Corporate")}
                </NavLink>
              </li>
              {/*<li>*/}
              {/*    <NavLink*/}
              {/*        onClick={handleMenuItem}*/}
              {/*        className={({ isActive }) => isActive ? `${styles.link} ${styles.active}` : styles.link}*/}
              {/*        to={"/gyms-location"}*/}
              {/*    >*/}
              {/*        {t("FindClassesAppointments")}*/}
              {/*    </NavLink>*/}
              {/*</li>*/}
            </ul>
          </nav>
          <div className={styles.language}>
            <LanguageSelect />
          </div>
          {/*{!isAuthorized ? (*/}
          {/*    <div className={styles.btnsWrapper}>*/}
          {/*        <CustomButton*/}
          {/*            text={"Login"}*/}
          {/*            type={"button"}*/}
          {/*            typeStyle={"outline"}*/}
          {/*            functionOnClick={() => handleOnLogin()}*/}
          {/*        />*/}
          {/*        <CustomButton*/}
          {/*            text={"Get started"}*/}
          {/*            type={"button"}*/}
          {/*            typeStyle={"fill"}*/}
          {/*            functionOnClick={() => handleOnGetStarted()}*/}
          {/*        />*/}
          {/*    </div>*/}
          {/*) : (*/}
          {/*    <button onClick={() => setShowConfirmPopupForLogout(true)} className={styles.signOut}>{t("SignOut")}</button>*/}
          {/*)}*/}
        </div>
      </div>
      {showConfirmPopupForLogout && (
        <ConfirmPopup
          iconPath={attentionIcon}
          title={t("AreYouSureYouWantToLogOut")}
          description={t("YouAreAboutToLogOutOfYourAccount")}
          onClickYes={handelSignOut}
          onClickNo={closeConfirmSignOutPopup}
        />
      )}
    </>
  );
};

export default BurgerMenu;
